import * as Sentry from '@sentry/browser';

export function setSentryUser(username) {
	Sentry.setUser({ username });
}

export function captureException(error) {
	Sentry.captureException(error);
}

export function sentryInit(params) {
	Sentry.init(params);
}
